import { Link } from 'found';
import React from 'react';

import { Typography } from '@mui/material';

import { palette } from '../../../../../assets/styles/themes/tokens';
import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';
import Tooltip from '../../../../Tooltip';
import { MuiCardBaseProps } from '../MuiCardBase';
import { colors } from '../../../../../assets/styles/themes/variables';
import useRouter from '../../../../../utils/useRouter';
import { getCardLinkProps, indexToPosition } from '../../../../../utils/searchUtils';

const MuiCardBaseLongTitle: React.FC<{
    title: MuiCardBaseProps['title'];
    itemLink: string;
    index?: number;
    openInNewTab?: boolean;
  }> = ({ title, itemLink, index, openInNewTab }) => {
    const { match } = useRouter();

    const linkProps = getCardLinkProps(
      itemLink,
      match.location.pathname,
      indexToPosition(index),
      { currentSearch: match.location.search, openInNewTab },
    );

    return (
      <Link
        to={linkProps}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
      >
        <Tooltip label={title} placement='top' hideWithoutOverflow={true}>
          <Typography
            variant='h5'
            data-testid='mui-card-desktop__title'
            sx={{
              ...getTextTruncationSx(2),
              color: palette.text.primary,
              transition: 'color 300ms ease-out',
              ':hover': {
                color: colors.blue500,
              },
            }}
          >
            {title}
          </Typography>
        </Tooltip>
      </Link>
    );
  };

export default MuiCardBaseLongTitle;
